module.exports = __webpack_public_path__ + "static/media/youtubefetcher.ac5c1f49.webp";